<template>
  <div id="Forkliftproducts">
    <div class="container-fluid px-3 py-3 bg">
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
      <h1 class="text-light">FORKLIFT FOR RENT</h1>
      <br>
      <h4 class="text-light mb-3">Choose with Your Needs</h4>
      <div class="row row-cols-1 row-cols-md-3 g-4">
        <template v-for="(ct, key) in content">
          <div :class="{ active: key }" :key="key">
            <div class="col">
              <div class="card h-100">
                <img :src="ct.Forktype" class="card-img-top" />
                <div class="card-body">
                  <h5 class="card-title">{{ ct.Forktypename }}</h5>
                  <p class="card-text">{{ ct.Text }}</p>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ForkProd",

  data: () => ({
    content: [
      {
        Forktype: "img/Forklift_Products/counter_balance.png",
        Forktypename: "Counter Balance",
        Text: "Call Us For More",
      },
      {
        Forktype: "img/Forklift_Products/reach_truck.png",
        Forktypename: "Reach Truck",
        Text: "Call Us For More",
      },
      {
        Forktype: "img/Forklift_Products/pallet_mover.png",
        Forktypename: "Pallet Mover",
        Text: "Call Us For More",
      },
      {
        Forktype: "img/Forklift_Products/hand_pallet.png",
        Forktypename: "Hand Pallet",
        Text: "Call Us For More",
      },
      {
        Forktype: "img/Forklift_Products/k_series.png",
        Forktypename: "K-Series",
        Text: "Call Us For More",
      },
      {
        Forktype: "img/Forklift_Products/costum_equipment.png",
        Forktypename: "Custom Equipment",
        Text: "Call Us For More",
      },
    ],
  }),
};
</script>

<style>
.bg {
  background: #1F1F1F;
}
</style>